import React from 'react';
import { useLang } from '../contexts/LanguageContext';

export default function LanguageToggle() {
  const { lang, setLang } = useLang();

  const baseBtn = "h-7 px-2.5 rounded-md text-[11px] font-semibold uppercase tracking-[0.08em] transition-all duration-150";

  return (
    <div
      className="flex items-center gap-0.5 rounded-lg p-[3px]"
      style={{
        background: 'var(--border-subtle)',
        border: '1px solid var(--border-default)',
      }}
      data-testid="language-toggle-group"
    >
      <button
        type="button"
        onClick={() => setLang('es')}
        data-testid="language-toggle"
        className={baseBtn + (lang === 'es' ? ' text-foreground' : ' text-muted-foreground/60 hover:text-muted-foreground')}
        style={lang === 'es' ? { background: 'var(--border-default)' } : undefined}
      >
        ES
      </button>
      <button
        type="button"
        onClick={() => setLang('en')}
        data-testid="language-toggle-en"
        className={baseBtn + (lang === 'en' ? ' text-foreground' : ' text-muted-foreground/60 hover:text-muted-foreground')}
        style={lang === 'en' ? { background: 'var(--border-default)' } : undefined}
      >
        EN
      </button>
    </div>
  );
}
